import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// One date style everywhere ("03 Nov 2026"), whatever the browser's locale.
export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  return isNaN(d) ? '—' : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  return isNaN(d) ? '—' : d.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

// Student profile type -> display label. Records without one are treated as masters, like the server.
export function profileTypeLabel(type) {
  const t = type || 'masters';
  return t === 'phd' ? 'PhD' : t === 'masters' ? "Master's" : "Bachelor's";
}
